/**
 * AnswerCell - one of the study's answer columns (docs/plans/crm-recruitment-list-plan.md Part A
 * section 4, decision 7, B4): the lead's landing-form answer to that question, with the question
 * as the tooltip. Yes / no answers read "Yes" / "No"; a multiple-choice answer arrives already
 * joined into one string; no answer reads as a dash.
 */
import type { RecruitAnswer, RecruitRow } from '../../types';

export interface AnswerCellProps {
  row: RecruitRow;
  /** The column's question_key (the key into row.answers). */
  questionKey: string;
  /** The column's label, used when the row carries none. */
  label?: string;
  className?: string;
}

/** The words for a stored answer; '' when there is none. */
export function answerText(value: RecruitAnswer['value'] | undefined): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'number') return Number.isFinite(value) ? value.toLocaleString() : '';
  return String(value).trim();
}

export function AnswerCell({ row, questionKey, label, className = '' }: AnswerCellProps) {
  const answers = row.answers || {};
  const answer = Object.prototype.hasOwnProperty.call(answers, questionKey) ? answers[questionKey] : undefined;
  const text = answerText(answer?.value);
  const question = answer?.label || label || questionKey;
  return (
    <span
      title={question}
      className={`block truncate text-xs ${text ? 'text-gray-700 dark:text-gray-200' : 'text-gray-400 dark:text-gray-500'} ${className}`}
    >
      {text || '—'}
    </span>
  );
}

export default AnswerCell;
